import * as React from "react"
import { Server } from "stellar-sdk"
import albedo from '@albedo-link/intent'
import { StaticImage } from "gatsby-plugin-image"

import Layout from "../components/layout"
import Seo from "../components/seo"
import { TOKENS } from "../utils/constants"

// More resources


const MinePage = () => {
  const pickupStone = async () => {
    albedo.pay({
      network: "testnet",
      asset_code: TOKENS.ENERGY.CODE,
      asset_issuer: TOKENS.ENERGY.ISSUER,
      destination: TOKENS.STONE.ISSUER,
      amount: Number(5).toFixed(7).toString(),
      submit: true
    })
    .then(res => { console.log(res);})
    .catch(console.log)
  };
  return <Layout>
    <Seo title="Mine" />
    <h2>The Mine</h2>
    <div className="action-card berries-action">
      <div className="action-description">
        Pickup small stones from the ground
      </div>
      <div className="action-requirements">
        <strong>NO TOOLS REQUIRED</strong>
      </div>
      <div className="action-cost">
        <strong>-5</strong> <StaticImage src={"../images/sleeping.png"} width={48} alt={TOKENS.ENERGY.CODE}/>
      </div>
      <div className="action-outcome">
        <strong>+5</strong> <StaticImage src={"../images/stone.png"} width={48} alt={TOKENS.STONE.CODE}/>
      </div>
      <div className="action-duration">
        <strong>10 min</strong>
      </div>
      <button onClick={pickupStone}>DO</button>
    </div>
  </Layout>
}

export default MinePage
